import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      width: "100%",
      backgroundColor: "#000000",
      margin: 0,
      padding: 0,
      position: "fixed",
      top: 0,
      left: 0,
    },
    paper: {
      textAlign: "center",
      maxWidth: 410,
      width: "45%",
      borderRadius: "2px",
      backgroundColor: "#ffffff",
      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
      margin: theme.spacing(2),
    },
    logo: {
      height: "50px",
      objectFit: "contain",
      maxWidth: "100%",
    },
    title: {
      marginTop: "30px",
      marginBottom: "20px",
    },
    message: {
      lineHeight: 1.5,
      fontSize: "14px",
      color: "#2d333a",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      "& button": {
        fontWeight: 400,
        fontSize: "16px !important",
        height: "48px",
        textTransform: "none",
      },
    },
    errorMessage: {
      lineHeight: 1.5,
      width: "100%",
      fontSize: "16px",
      fontWeight: 400,
      color: "white",
      marginTop: "8px",
      backgroundColor: "#CC011C",
      padding: "13px 16px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  }),
);
